import React, {useState} from "react";
import {Button, message, Modal, Typography} from "antd";
import {AlertTriangle, Trash2} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {APIv1} from "../../../api";
import {playFeedbackWave} from "../../../utils/feedbackWave";

const {Text} = Typography;

const DeleteModel = ({id, token, licenseDeviceId}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [deleting, setDeleting] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const closeDeleteModal = () => {
        if (!deleting) {
            setDeleteModalOpen(false);
        }
    };

    const handleDelete = async () => {
        if (!token || !id || deleting) {
            return;
        }

        setDeleting(true);

        try {
            await APIv1.delete(`/device/license/delete/${id}/`, {
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            playFeedbackWave('success');
            message.success(t("pages.markerMobile.messages.deleteSuccess"));
            setDeleteModalOpen(false);
            navigate("/devices/marker-mobile");
        } catch (error) {
            console.error("Error deleting marker mobile license:", error);
            playFeedbackWave('failure');
            message.error(t("pages.markerMobile.messages.deleteError"));
        } finally {
            setDeleting(false);
        }
    };

    return (
        <>
            <button
                className="detail-view__action-button detail-view__action-button--secondary marker-mobile-detail__delete-button"
                disabled={deleting}
                onClick={() => setDeleteModalOpen(true)}
            >
                <Trash2 size={16}/>
                {t("pages.markerMobile.deleteConfirm.confirm")}
            </button>

            <Modal
                centered
                destroyOnClose
                className="marker-mobile-delete-modal"
                title={null}
                open={deleteModalOpen}
                width={620}
                onCancel={closeDeleteModal}
                footer={[
                    <Button
                        key="cancel"
                        disabled={deleting}
                        onClick={closeDeleteModal}
                    >
                        {t("pages.markerMobile.deleteConfirm.cancel")}
                    </Button>,
                    <Button
                        key="delete"
                        danger
                        type="primary"
                        icon={<Trash2 size={16}/>}
                        loading={deleting}
                        onClick={handleDelete}
                    >
                        {t("pages.markerMobile.deleteConfirm.confirm")}
                    </Button>,
                ]}
            >
                <div className="marker-mobile-delete-modal__content">
                    <div className="marker-mobile-delete-modal__icon">
                        <AlertTriangle size={28}/>
                    </div>
                    <div className="marker-mobile-delete-modal__copy">
                        <h2>{t("pages.markerMobile.deleteConfirm.title")}</h2>
                        <p>{t("pages.markerMobile.deleteConfirm.description")}</p>
                        <div className="marker-mobile-delete-modal__target">
                            <span>{t("pages.markerMobile.listColumns.licenseDeviceId")}</span>
                            <Text copyable>{licenseDeviceId}</Text>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default DeleteModel;
